import React from 'react';
import { Globe2 } from 'lucide-react';

const UsaComplianceInformation = () => (
  <div className="space-y-3">
    <div className="space-y-2 text-xs leading-relaxed text-gray-400">
      <p><em className="font-semibold text-[#38bdf8]">Why is this required?</em><br />US telecom requirements mandate verification to help prevent misuse. Your number is passed to the verification process only for this purpose and is not retained in the PhantomPath customer database.</p>
      <p><em className="font-semibold text-[#38bdf8]">Privacy by design:</em> In line with the data-minimisation and purpose-limitation principles of UK GDPR Article 5, we only process information necessary to provide and protect the service.</p>
    </div>

    <div className="flex items-start gap-2.5 rounded-lg bg-white/[0.045] px-3 py-2.5">
      <Globe2 className="mt-0.5 h-4 w-4 shrink-0 text-[#00ffc8]" aria-hidden="true" />
      <div className="text-xs leading-relaxed">
        <p className="font-bold text-white">Global mobile numbers accepted</p>
        <p className="mt-0.5 text-gray-300">This does not need to be a US number. Enter any valid mobile number using its international country code.</p>
      </div>
    </div>
  </div>
);

export default UsaComplianceInformation;
